/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import classNames from 'classnames';
import { useState } from 'react';
import styles from './FeaturesSection.module.scss';

const FeaturesSection: PageComponent = () => {
    const recommendsMax = 2;
    const [acitvePlan, setActivePlan] = useState(0);
    const prevActivePlan = () => {
        let index = acitvePlan;
        if (index < 1) {
            index = recommendsMax;
        } else {
            index -= 1;
        }
        setActivePlan(index);
    };
    const nextActivePlan = () => {
        let index = acitvePlan;
        if (index === recommendsMax) {
            index = 0;
        } else {
            index += 1;
        }
        setActivePlan(index);
    };
    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <div
                    className={classNames(styles.container_inner, {
                        [styles.active]: acitvePlan === 0,
                    })}
                >
                    <span
                        className={styles.prev}
                        onClick={(e) => {
                            e.preventDefault();
                            prevActivePlan();
                        }}
                    />
                    <span
                        className={styles.next}
                        onClick={(e) => {
                            e.preventDefault();
                            nextActivePlan();
                        }}
                    />
                    <div className={styles.inside}>
                        <div className={styles.icon}>
                            <img src="/static/img/icons/team.svg" />
                        </div>
                        <h3>52'000+</h3>
                        <p>
                            <Trans
                                i18nKey="features.client.title"
                                ns="landingInformationAboutCompany"
                            >
                                patenkintu klientų
                            </Trans>
                        </p>
                    </div>
                </div>
                <div
                    className={classNames(styles.container_inner, {
                        [styles.active]: acitvePlan === 1,
                    })}
                >
                    <span
                        className={styles.prev}
                        onClick={(e) => {
                            e.preventDefault();
                            prevActivePlan();
                        }}
                    />
                    <span
                        className={styles.next}
                        onClick={(e) => {
                            e.preventDefault();
                            nextActivePlan();
                        }}
                    />
                    <div className={styles.inside}>
                        <div className={styles.icon}>
                            <img src="/static/img/icons/database.svg" />
                        </div>
                        <h3>8'500+</h3>
                        <p>
                            <Trans
                                i18nKey="features.servers.title"
                                ns="landingInformationAboutCompany"
                            >
                                serverių
                            </Trans>
                        </p>
                    </div>
                </div>
                <div
                    className={classNames(styles.container_inner, {
                        [styles.active]: acitvePlan === 2,
                    })}
                >
                    <span
                        className={styles.prev}
                        onClick={(e) => {
                            e.preventDefault();
                            prevActivePlan();
                        }}
                    />
                    <span
                        className={styles.next}
                        onClick={(e) => {
                            e.preventDefault();
                            nextActivePlan();
                        }}
                    />
                    <div className={styles.inside}>
                        <div className={styles.icon}>
                            <img src="/static/img/icons/settings-alt.svg" />
                        </div>
                        <h3>17+</h3>
                        <p>
                            <Trans
                                i18nKey="features.experience.title"
                                ns="landingInformationAboutCompany"
                            >
                                metų patirties
                            </Trans>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
